module.exports = __webpack_public_path__ + "img/ic_32_exercises_warmup.661da673.svg";